/**
 * Plausibility check of an e-mail address: exactly one "@", no whitespace, a dot in the domain. Same rule as
 * account-management (ProfileResource.EMAIL); whether the address really receives mail only its verification shows.
 */
export function isValidEmail(email: string): boolean {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
